module.exports = __webpack_public_path__ + "static/3adjust-dac589aafadcd38a699e000b5acf41b5.png";